import { useReveal } from "@/hooks/useReveal";

interface Testimonial {
  id: number;
  client_name: string;
  client_title: string;
  company: string;
  quote: string;
  rating: number;
  industry: string;
}

const testimonials: Testimonial[] = [
  {
    id: 1,
    client_name: "James Whitfield",
    client_title: "CTO",
    company: "Northgate Financial",
    quote: "Vantory Labs transformed our legacy system into a modern cloud-based platform in just 14 weeks. Their team understood our complex requirements from day one.",
    rating: 5,
    industry: "Fintech",
  },
  {
    id: 2,
    client_name: "Sarah Chen",
    client_title: "Product Director",
    company: "MediConnect Health",
    quote: "The healthcare app they built for us exceeded all expectations. Patient engagement increased by 340% within three months of launch.",
    rating: 5,
    industry: "Healthcare",
  },
  {
    id: 3,
    client_name: "Marcus Okafor",
    client_title: "Founder & CEO",
    company: "ShopStream Retail",
    quote: "Not just developers — true strategic partners. They helped us refine our product vision and delivered a platform that scaled with our growth.",
    rating: 5,
    industry: "E-Commerce",
  },
];

export default function Testimonials() {
  const ref = useReveal<HTMLDivElement>();

  return (
    <section ref={ref} className="bg-cream py-24 md:py-32">
      <div className="mx-auto max-w-[1320px] px-6 md:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14" data-reveal>
          <div>
            <span className="text-xs uppercase tracking-widest2 text-ink/60">Client stories</span>
            <h2 className="mt-4 text-display text-4xl md:text-6xl leading-[1.05] text-balance max-w-2xl">
              Results that <span className="italic font-light">matter.</span>
            </h2>
          </div>
          <div className="flex items-center gap-3 text-sm text-ink/70">
            <div className="flex">
              {[1,2,3,4,5].map((s) => (
                <i key={s} className="ri-star-fill text-terracotta text-lg w-5 h-5 flex items-center justify-center" />
              ))}
            </div>
            <span><span className="font-semibold text-ink">4.9 / 5</span> · 1635 client reviews</span>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
          {testimonials.map((t, i) => (
            <article
              key={t.id}
              data-reveal
              data-reveal-delay={`${i * 100}`}
              className="relative rounded-3xl overflow-hidden bg-sand border border-ink/5 p-8 md:p-10"
            >
              <div className="flex items-center gap-2 mb-6">
                <span className="rounded-full bg-lime-accent px-3 py-1 text-[10px] uppercase tracking-widest2 font-semibold text-ink">
                  {t.industry}
                </span>
              </div>

              <p className="text-display text-xl md:text-2xl leading-snug text-balance mb-8">
                &ldquo;{t.quote}&rdquo;
              </p>

              <div className="pt-6 border-t border-ink/10 flex items-center justify-between">
                <div>
                  <p className="text-sm font-semibold">{t.client_name}</p>
                  <p className="text-xs text-ink/55">{t.client_title}, {t.company}</p>
                </div>
                <div className="flex">
                  {Array.from({ length: t.rating }).map((_, j) => (
                    <i key={j} className="ri-star-fill text-terracotta text-sm w-4 h-4 flex items-center justify-center" />
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}